import { getGclid } from '../utils/gclid';
import { getMetaAdsParams } from '../utils/metaAds';

const baseAPI_URL = process.env.REACT_APP_BACKEND_API_BASE_ENDPOINT;

export async function createPixSubscription1({
  name,
  cpf,
  email,
  phone,
  period,
  offer,
  origin
}) {

  const payload = {
    name,
    cpfCnpj: cpf,
    email,
    phone,
    value: offer.prices.pix,
    offer_code: offer.code,
    period,
    cep: '',
    address: '',
    province: '',
    addressNumber: '',
    addressComplement: '',
    origin: origin
  };

  const response = await fetch(
    `${baseAPI_URL}/new_subscriptions/create-pix-subscription1`,
    {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(payload)
    }
  );

  if (!response.ok) {
    const errorData = await response.json();

    throw {
      status: response.status,
      data: errorData
    };
  }

  const result = await response.json();

  return result;
}

export async function createPixSubscription2({
  name,
  cpf,
  email,
  phone,
  period,
  offer,
  subscription,
  payments,
  origin,
  gclid
}) {

  const resolvedGclid = gclid ?? getGclid();

  const payload = {
    name,
    cpfCnpj: cpf,
    email,
    phone,
    offer_code: offer.code,
    period,
    cep: '',
    address: '',
    province: '',
    addressNumber: '',
    addressComplement: '',
    subscription,
    payments,
    origin: origin,
    ...(resolvedGclid ? { gclid: resolvedGclid } : {}),
    ...getMetaAdsParams()
  };

  const response = await fetch(
    `${baseAPI_URL}/new_subscriptions/create-pix-subscription2`,
    {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(payload)
    }
  );

  if (!response.ok) {
    const errorData = await response.json();

    throw {
      status: response.status,
      data: errorData
    };
  }

  const result = await response.json();

  return result;
}

export async function createCardSubscription({
  name,
  cpf,
  email,
  phone,
  period,
  offer,
  n_inst,
  cep,
  endereco,
  card_name,
  card_number,
  card_month,
  card_year,
  card_cvv,
  origin,
  gclid
}) {

  const resolvedGclid = gclid ?? getGclid();

  const payload = {
    name,
    cpfCnpj: cpf,
    email,
    phone,
    offer_code: offer.code,
    n_inst,
    period,

    cep,
    address: endereco.rua,
    province: endereco.bairro,
    addressNumber: endereco.numero,
    addressComplement: endereco.complemento,

    holderName: card_name,
    cardNumber: card_number,
    expiryMonth: card_month,
    expiryYear: card_year,
    cvv: card_cvv,

    origin: origin,
    ...(resolvedGclid ? { gclid: resolvedGclid } : {}),
    ...getMetaAdsParams()
  };

  const response = await fetch(
    `${baseAPI_URL}/new_subscriptions/create-credit-card-subscription`,
    {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(payload)
    }
  );

  if (!response.ok) {
    const errorData = await response.json();

    throw {
      status: response.status,
      data: errorData
    };
  }

  const result = await response.json();

  return result;
}

export async function createInitiateCheckoutLead({
  name,
  email,
  phone
}) {

  const payload = {
    name,
    email,
    phone
  };

  const response = await fetch(
    `${baseAPI_URL}/email/leads`,
    {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(payload)
    }
  );

  if (!response.ok) {
    const errorData = await response.json();

    throw {
      status: response.status,
      data: errorData
    };
  }

  const result = await response.json();

  return result;
}